var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-0 py-0 mb-0",attrs:{"dense":""}},[_c('v-card-title',{staticClass:"subtitle-2"},[_vm._v("\n        "+_vm._s(_vm.field.title)+"\n    ")]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.field.description))]),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.field.html.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }